export const ApiDef_FHIRResourceParam = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map